import React,{useState,useEffect, useRef} from 'react'
import './chatbot.css';

import chatbotServices from '../../chatbotServices';
import { Attachment, Phone, Send } from '@mui/icons-material';

import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import ConversationView from './ConversationView';
import ChatAudioInput from './ChatAudioInput';
import ChatLocationInput from './ChatLocationInput';
import ChatImageInput from './ChatImageInput';
import { useAlert } from '../../../context/AlertContext';
import RequestPhoneNo from '../common/RequestPhoneNo';
import { ChatInputProvider } from './chat-context/ChatInputContext';
import { useChatConversationProvider } from '../../../context/ConversationContext';
import SuggestionList from './SuggestionList';




function ChatBotComponent() {
    const messagesEndRef = useRef(null);
	const messageInputRef = useRef(null);
	const {AppAlert} = useAlert();
    const [messageInput,setMessageInput] = useState("");
    //const [conversationList,setConversationList] = useState([]);
	const {conversationList,setConversationList} = useChatConversationProvider();
    const [loading,setLoadingStatus] = useState(false);

    
    const [chatUserPhone,setChatUserPhone] = useState(localStorage.getItem("customerPhone")); 
    const [requestPhoneNoDialogStatus, setRequestPhoneNoDialogStatus] = useState(false);
    const [nextPayload,setNextPayload] = useState(null);

	const handlePhoneNoChange = (phoneNo) =>{
		setChatUserPhone(phoneNo);
		setLoadingStatus(true);
		let payload = {...nextPayload};
		payload.from = phoneNo;
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
			setNextPayload(null);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{
			setLoadingStatus(false);	
			setRequestPhoneNoDialogStatus(false);
		})
	}


    const updateConversation = (message,type,dataType="text") =>{
		let _message = {
			msg : message,
			type : type,
			dataType:dataType,
		}
		//let _conversationList = [...conversationList,_message]; // bug when use this method two time in one function
		setConversationList(_conversationList=>[..._conversationList,_message])		
		setMessageInput("");
		messageInputRef.current.focus();
	}


    const handleResponse = (res) =>{
		setTimeout(()=>{
			if(res.data !==null){
                console.log(res.data);
                if(res.data.messageType === "askPhoneNo"){
                    setNextPayload(res.postData);
                    setRequestPhoneNoDialogStatus(true);
                } else {
                    updateConversation(res.data,"i")
                }
			}
			setLoadingStatus(false)
		},[1000])
	}

    const sendTextMessage = () =>{

		if(messageInput.length === 0 ){
			return false;
		}
		let payload = {
			messageType : "text",
			message:messageInput,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		updateConversation(messageInput,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendSuggestionMessageId = (option) =>{
		let payload = {
			messageType : "interactiveReply",
			id:option.optionId,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		updateConversation(option.optionTitle,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const openMainMenu = () =>{
		let payload = {
			messageType : "text",
			message:"menu",
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		updateConversation("Menu","o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const sendInterectiveMessage = (option,messageType) =>{
		let payload = {
			messageType : messageType,
			id:option.optionId,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		console.log(option)
		updateConversation(option.optionTitle,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const sendImageMessage = (url) =>{
		let payload = {
			messageType : "imageRequest",
			url:url,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(url,"o","image")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendAudioMessage = (url) =>{
		let payload = {
			messageType : "audioRequest",
			url:url,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(url,"o","audio")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendLocationMessage = (location) =>{
		let payload = {
			messageType : "locationRequest",
			location:location,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(location,"o","location")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const initiateConversation = () =>{
		let payload = {
			messageType : "text",
			message:"hi",
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		//updateConversation("hi","o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    useEffect(()=>{
		console.log(conversationList)
		if(conversationList.length === 0){
			initiateConversation();
		}
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	},[conversationList])

    return (
		<>
		<ChatInputProvider>
        <div className='container p-0'>
            <div className='card p-0 border-0'>
                
                <div className='card-body' style={{height:"70vh", overflowY:"scroll"}}>
                    <ConversationView conversationList={conversationList} sendInterectiveMessage={sendInterectiveMessage} />
					{loading && <div className='p-3'><CircularProgress /></div> }
					<div ref={messagesEndRef} />
                </div>
                <div className='card-footer bg-white m-2 p-3 mb-4 border rounded-3'>
						{chatUserPhone !== null &&
                        <ul className="dropdown-menu">
							<li><ChatImageInput callBack={sendImageMessage} chatUserPhone={chatUserPhone} /></li>
							<li><ChatLocationInput callBack={sendLocationMessage} /></li>
						</ul>
						}
						{chatUserPhone !== null && <ChatAudioInput callBack={sendAudioMessage} chatUserPhone={chatUserPhone} /> }
                    <div className="row">
                        <div className="col-md-12">
                        
							<input type="text" className="form-control border-0" placeholder="Type Your Message Here..."
								value={messageInput}
								ref={messageInputRef}
								onChange={(e)=>setMessageInput(e.target.value)}
								onKeyUp={ (e) =>{
									if(e.key === 'Enter') {
										e.preventDefault();
										sendTextMessage()
									}
								}}
							/>
						</div>
						<div className="col-md-12">
							<div className="d-flex justify-content-between">
								<div><SuggestionList sendSuggestionMessageId={sendSuggestionMessageId} openMainMenu={openMainMenu} /></div>
                        		<button disabled={messageInput.length == 0} className="float-end btn btn-outline-secondary border-0 text-success" type="button" id="button-addon3" onClick={sendTextMessage}><Send /></button>
							</div>
						</div>

                    </div>
                </div>
            </div>
			<RequestPhoneNo requestStatus={requestPhoneNoDialogStatus} callback={handlePhoneNoChange} />
        </div>
		</ChatInputProvider>
        </>
    )
}

export default ChatBotComponent